/* eslint-disable react-refresh/only-export-components --
 * Context module: Provider + hook are intentionally co-located.
 */
import React, { createContext, useContext, useMemo } from 'react';

/** One repeating row: `{ value }` equals schema option string; `label` matches OASISM display label. */
export type RepeatBindingItem = { value: string; label: string };

/** Map repeat alias (e.g. `opt`) → current row item — merged from nested `repeat` scopes. */
export type RepeatBindings = Record<string, RepeatBindingItem>;

const RepeatBindingsContext = createContext<RepeatBindings>({});

export function RepeatBindingsProvider({
  parent,
  merge,
  children,
}: {
  parent: RepeatBindings;
  merge: RepeatBindings;
  children: React.ReactNode;
}) {
  const value = useMemo(() => ({ ...parent, ...merge }), [parent, merge]);
  return (
    <RepeatBindingsContext.Provider value={value}>
      {children}
    </RepeatBindingsContext.Provider>
  );
}

export function useRepeatBindings(): RepeatBindings {
  return useContext(RepeatBindingsContext);
}
